import React from 'react';
import { inject, observer } from "mobx-react";
import { Container, Row, Col, Form, InputGroup, Button, OverlayTrigger, Tooltip, Spinner, Alert } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";

@inject("formStore")
@observer
class LoginForm extends React.Component {
    render() {
        const s = this.props.formStore;
        const tooltip = (
            <Tooltip id="order-number-tooltip">
                מספר ההזמנה מורכב מ-8 תווים (מתחיל בספרה 5 או 305)
            </Tooltip>
        );

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                width: '100%'
            }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={8} md={6} lg={4}>
                            <div style={{
                                border: '1px solid #ced4da',
                                borderRadius: '.25rem',
                                padding: '2rem',
                                backgroundColor: '#fff',
                                boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.26)'
                            }}>
                                {/* Logo Row */}
                                <Row className="mb-4">
                                    <Col className="text-center">
                                        <div className="kv-logo" style={{ margin: '0 auto' }} />
                                    </Col>
                                </Row>

                                {/* Text Row */}
                                <Row className="mb-4">
                                    <Col className="text-center">
                                        <h1>ברוכים הבאים</h1>
                                        <h4>לאזור השלמת פרטי נוסע</h4>
                                        <p style={{ fontSize: '18px', fontWeight: 400, margin: 0 }}>
                                            כאן תוכלו לעדכן את פרטי הנוסעים להזמנה שביצעתם בהתאם לדרישות חברת התעופה.

                                        </p>
                                    </Col>
                                </Row>

                                {/* Input Field Row */}
                                <Row className="mb-4">
                                    <Col>
                                        <Form>
                                            <Form.Group>
                                                <InputGroup>
                                                    <Form.Control
                                                        value={s.orderNumber.value}
                                                        onChange={(e) => s.orderNumber.setValue(e.target.value)}
                                                        type="text"
                                                        placeholder="מספר הזמנה"
                                                        maxLength={8}
                                                    />
                                                    <InputGroup.Append>
                                                        <OverlayTrigger placement="top" overlay={tooltip}>
                                                            <InputGroup.Text style={{ cursor: 'help' }}>
                                                                ?
                                                            </InputGroup.Text>
                                                        </OverlayTrigger>
                                                    </InputGroup.Append>
                                                </InputGroup>
                                            </Form.Group>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row className="mb-4" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <ReCAPTCHA
                                        sitekey="6LcRrG0rAAAAADv7OYwDdpzKxvryOQnQDivCbOmo"
                                        onChange={(token) => {
                                            s.setReCaptchaToken(token);
                                            console.log("reCAPTCHA token:", token);
                                        }}
                                    />
                                </Row>
                                {/* Error Message Row */}
                                {s.loginError && (
                                    <Row className="mb-3">
                                        <Col>
                                            <Alert variant="danger">
                                                אחד מהפרטים חסר או לא תקין
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}
                                {/* Button Row */}
                                <Row>
                                    <Col>
                                        <Button
                                            variant="primary"
                                            block
                                            style={{ fontSize: '16px', fontWeight: 700 }}
                                            disabled={!s.reCaptchaToken || !s.orderNumberIsValid || s.isLoggingIn}
                                            onClick={() => { s.pefromLogin() }}
                                        >
                                            {s.isLoggingIn ? (
                                                <>
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        style={{ marginRight: '8px' }}
                                                    />&nbsp;
                                                    מתחבר...
                                                </>
                                            ) : (
                                                'כניסה'
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default LoginForm;